import { ProtocolSettings } from "./ProtocolSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";
import { ObjUtils } from "../Utils/ObjUtils";
import { ValueEncoder } from "../Utils";

export class PrtgSettings extends ProtocolSettings {

	public static readonly DefaultUrl: string = "http://127.0.0.1/";
	public static readonly DefaultUserName: string = "prtgadmin";
	public static readonly DefaultHttpPort: number = 9944;
	public static readonly DefaultHttpsPort: number = 9945;

	public ServerUrl: string;
	public UserName: string;
	public Passhash: string;
	public ServicePort: string;
	public HttpPushServicePort: string;
	public ServiceApiKey: string;
	public IsHostedPRTG: boolean;

	constructor() {
		super();

		this.ServerUrl = PrtgSettings.DefaultUrl;
		this.UserName = PrtgSettings.DefaultUserName;
		this.Passhash = "";
		this.ServicePort = "";
		this.HttpPushServicePort = "5050";
		this.ServiceApiKey = "";
		this.IsHostedPRTG = false;
	}

	public get HasServerUrl(): boolean {
		return !!this.ServerUrl;
	}

	public get HasUserName(): boolean {
		return !!this.UserName;
	}

	public get HasPasshash(): boolean {
		return !!this.Passhash;
	}

	public get HasServicePort(): boolean {
		return !!this.ServicePort;
	}

	public get HasHttpPushServicePort(): boolean {
		return !!this.HttpPushServicePort;
	}

	public get HasServiceApiKey(): boolean {
		return !!this.ServiceApiKey;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.Prtg;
	}

	public get Summary(): string {
		return `Server URL: ${this.ServerUrl}; Username: ${this.UserName}`;
	}

	public GetTargetIpHost(): string {
		let targetName = "";

		if (this.HasServerUrl) {
			let startIndex: number = this.ServerUrl.indexOf("//");
			if (startIndex >= 0) {
				let nextIndex = -1;
				let endIndex = -1;

				// STEP over "//"
				startIndex += 2;

				endIndex = this.ServerUrl.indexOf("/", startIndex);
				if (endIndex < 0)
					endIndex = this.ServerUrl.length;

				nextIndex = this.ServerUrl.indexOf(":", startIndex);
				if (nextIndex >= 0) {
					if (nextIndex < endIndex)
						endIndex = nextIndex;
				}

				targetName = this.ServerUrl.substr(startIndex, (endIndex - startIndex));
			}
		}

		return targetName;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof PrtgSettings))
			return;
		let other = (obj as PrtgSettings);

		super.Copy(obj);

		this.ServerUrl = other.ServerUrl;
		this.UserName = other.UserName;
		this.Passhash = other.Passhash;
		this.ServicePort = other.ServicePort;
		this.HttpPushServicePort = other.HttpPushServicePort;
		this.ServiceApiKey = other.ServiceApiKey;
		this.IsHostedPRTG = other.IsHostedPRTG;
	}

	public Clone(): ProtocolSettings {
		let clone = new PrtgSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof PrtgSettings))
			return false;
		let other: PrtgSettings = (obj as PrtgSettings);

		return (ObjUtils.Equals(this.ServerUrl, other.ServerUrl) &&
			ObjUtils.Equals(this.UserName, other.UserName) &&
			ObjUtils.Equals(this.Passhash, other.Passhash) &&
			ObjUtils.Equals(this.ServicePort, other.ServicePort) &&
			ObjUtils.Equals(this.HttpPushServicePort, other.HttpPushServicePort) &&
			ObjUtils.Equals(this.ServiceApiKey, other.ServiceApiKey) &&
			ObjUtils.Equals(this.IsHostedPRTG, other.IsHostedPRTG));
	}

	public Write(obj: any, context: any): void {
		obj.prtg = {};
		obj = obj.prtg;

		super.Write(obj, context);

		if (this.HasServerUrl)
			obj.server_url = this.ServerUrl;

		if (this.HasUserName)
			obj.user_name = this.UserName;

		if (this.HasPasshash)
			obj.passhash = this.Passhash;

		if (this.HasServicePort)
			obj.service_port = this.ServicePort;

		if (this.HasHttpPushServicePort)
			obj.push_service_port = this.HttpPushServicePort;

		if (this.HasServiceApiKey)
			obj.service_api_key = this.ServiceApiKey;

		if (this.IsHostedPRTG)
			obj.is_hosted_prtg = ValueEncoder.EncodeBoolean(this.IsHostedPRTG);
	}

	public Read(obj: any, context: any): void {
		if (!obj.prtg)
			throw new Error();
		obj = obj.prtg;

		super.Read(obj, context);

		if (obj.server_url !== undefined)
			this.ServerUrl = obj.server_url;

		if (obj.user_name !== undefined)
			this.UserName = obj.user_name;

		if (obj.passhash !== undefined)
			this.Passhash = obj.passhash;

		if (obj.service_port !== undefined)
			this.ServicePort = obj.service_port;

		if (obj.push_service_port !== undefined)
			this.HttpPushServicePort = obj.push_service_port;

		if (obj.service_api_key !== undefined)
			this.ServiceApiKey = obj.service_api_key;

		if (obj.is_hosted_prtg !== undefined)
			this.IsHostedPRTG = ValueEncoder.DecodeBoolean(obj.is_hosted_prtg);
	}

}

